module.exports = __webpack_public_path__ + "static/img/privacy-1-1.09c6e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-1-1.png
// module id = aeFf
// module chunks = 1